import { EnhancedAccount } from "library/accounts/types";
import { ActionMap } from "library/ActionMap";
import { components } from "library/api/card-management-service.generated";
import { FullPersonalDetails } from "../types";

export enum Status {
  INITIAL = "INITIAL",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  VERIFY = "VERIFY",
  VERIFY_ERROR = "VERIFY_ERROR",
  EXPIRED_OTP = "EXPIRED_OTP",
  EXPIRED_OTP_SUCCESS = "EXPIRED_OTP_SUCCESS",
}
export type State =
  | { status: Status.INITIAL | Status.ERROR | Status.EXPIRED_OTP_SUCCESS }
  | {
      status: Status.SUCCESS;
      phoneOtpResponse: components["schemas"]["PhoneVerifyResponse"];
    }
  | {
      status: Status.EXPIRED_OTP;
      token: string;
      createSessionUrl: string;
    }
  | {
      status: Status.VERIFY;
      token: string;
      updatePhoneVerify: string;
      updatePhoneResend: string;
    }
  | {
      status: Status.VERIFY_ERROR;
      title: string;
      message: string;
    };

export type LocationState = {
  account: EnhancedAccount;
  personalDetails: FullPersonalDetails;
};

export enum ActionTypes {
  BACK = "BACK",
  EXPIRED_OTP = "EXPIRED_OTP",
  EXPIRED_OTP_SUCCESS = "EXPIRED_OTP_SUCCESS",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  VERIFY = "VERIFY",
  VERIFY_OTP_EXPIRED = "VERIFY_OTP_EXPIRED",
  OTP_EXCEEDED_ALLOWED_LIMITS = "OTP_EXCEEDED_ALLOWED_LIMITS",
}

export type Payloads = {
  [ActionTypes.SUCCESS]: {
    payload: { phoneOtpResponse: components["schemas"]["PhoneVerifyResponse"] };
  };
  [ActionTypes.VERIFY]: {
    payload: {
      mobileNumber: string;
      token: string;
      updatePhoneVerify: string;
      updatePhoneResend: string;
    };
  };
  [ActionTypes.EXPIRED_OTP]: {
    payload: { createSessionUrl: string; token: string; mobileNumber: string };
  };
  [ActionTypes.OTP_EXCEEDED_ALLOWED_LIMITS]: {
    payload: { title: string; message: string };
  };
  [ActionTypes.VERIFY_OTP_EXPIRED]: {
    payload: { title: string; message: string };
  };
};

export type Actions = ActionMap<ActionTypes, Payloads>;

export type PhoneNumbersFormValues = {
  mobileNumber: string;
};
